import {
  ListAuditTemplatesCommand,
  type ListAuditTemplatesCommandInput,
  type ListAuditTemplatesCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { apiHeliosClient } from '../index';
import { v2TemplateKeys } from './keys';

/**
 * v2 React Query hook for listing audit templates scoped to a business unit.
 * Query stays idle until `businessUnitId` is supplied.
 */
export const useTemplatesQuery = <TData = ListAuditTemplatesCommandOutput>(
  input: Partial<ListAuditTemplatesCommandInput>,
  options?: Omit<
    UseQueryOptions<ListAuditTemplatesCommandOutput, Error, TData>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<TData> =>
  useQuery({
    ...options,
    queryKey: v2TemplateKeys.list(input),
    enabled: (options?.enabled ?? true) && !!input.businessUnitId,
    queryFn: () => {
      if (!input.businessUnitId) {
        throw new Error('businessUnitId is required to list templates');
      }
      return apiHeliosClient.send(
        new ListAuditTemplatesCommand({
          ...input,
          businessUnitId: input.businessUnitId,
          isActive: true,
        }),
      );
    },
  });
